/* eslint-disable react/jsx-curly-newline */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useContext, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useHistory, useParams } from 'react-router-dom';
import {
  TableBody,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@material-ui/core';
import { useRecoilState, useSetRecoilState } from 'recoil';
import LoadingOverlay from 'react-loading-overlay';
import AuthenticatedContext from '../../context/AuthenticatedContext';
import {
  backPageFlg,
  eqAchieveListPageInfo,
  pageTitle,
} from '../../context/PageRecoil';
import { pathnames } from '../../api';
import useStyles, { blank, headerWidth } from '../../css/style';
import Paging from '../paging';
import { OneEquipment } from '../../models/data/Equipment';
import { requestOneEquipment } from '../../api/equipment';
import DataDisp from './datadisp';
import { routeName } from '../../App';
import EqMaint from '../../models/data/EqMaint';
import requestEqMaintList, { requestCountEqMaint } from '../../api/eqMaint';
import useErrorHandling from '../errorCheck';

type UserPageParams = {
  id: string;
};

/**
 * 設備点検履歴画面
 */
const EqAchievelist: React.FunctionComponent = () => {
  const history = useHistory();
  const [pageInfo] = useRecoilState(eqAchieveListPageInfo);
  const authContext = useContext(AuthenticatedContext); // ログインユーザの情報を取得
  const classes = useStyles();
  const [loading, setLoading] = useState(true); // ロード画面の状態管理
  const { id } = useParams<UserPageParams>();
  const [backFlg, setBackFlg] = useRecoilState(backPageFlg);
  const [data, setData] = useState<EqMaint[]>([]); // 表示するメインデータ
  const [subdata, setSubData] = useState<OneEquipment>();
  const containerRef = React.useRef<HTMLDivElement>(null);
  const [scroll, setScroll] = useState<number>(0); // テーブルのスクロール位置
  const { errorCheck } = useErrorHandling(); // エラー処理
  const [nowYear, setNowYear] = useState<number | null>(null);

  const setPageTitle = useSetRecoilState(pageTitle);
  React.useEffect(() => {
    return setPageTitle({ pageTitle: '設備点検実績一覧' }); // ページのタイトルを設定
  }, [setPageTitle]);

  // APIのURL
  const urlEqMaintList = history.createHref({
    pathname: pathnames.eqMaintList,
  }); // 設備点検履歴一覧取得
  const urlCounteqMaint = history.createHref({
    pathname: pathnames.eqMaintCount,
  }); // 設備点検履歴件数取得
  const urlOneEquipment = history.createHref({
    pathname: pathnames.oneEquipment,
  }); // 設備情報取得
  // ページング用の変数
  const [totalData, setTotalData] = useState<number>(0); // データ数
  const [currentPage, setCurrentPage] = useState<number>(1); // 現在のページ
  const perPage = 20; // 一覧一ページあたりの表示件数

  // ソート用の変数
  type SortConfigType = { key: string; direction: string };
  const [sortConfig, setSortConfig] = React.useState<SortConfigType>({
    key: '',
    direction: '',
  });

  const headerCellProps = [
    {
      width: headerWidth.achieveMstId,
      sortKey: 'mstId',
      text: '機器ID',
      className: classes.header,
    },
    {
      width: headerWidth.achieveDeviceNameDsp,
      sortKey: 'deviceNameDsp',
      text: '機器名',
      className: classes.header,
    },
    {
      width: headerWidth.achieveSeizoNo,
      sortKey: 'seizoNo',
      text: '製造番号',
      className: classes.header,
    },
    {
      width: headerWidth.achieveNonyuYear,
      sortKey: 'nonyuYear',
      text: '製造年',
      className: classes.header,
    },
    {
      width: headerWidth.achieveY14,
      sortKey: 'y14',
      text: `${nowYear != null ? (nowYear - 14) % 100 : ''}`,
      className: classes.header,
    },
    {
      width: headerWidth.achieveY13,
      sortKey: 'y13',
      text: `${nowYear != null ? (nowYear - 13) % 100 : ''}`,
      className: classes.header,
    },
    {
      width: headerWidth.achieveY12,
      sortKey: 'y12',
      text: `${nowYear != null ? (nowYear - 12) % 100 : ''}`,
      className: classes.header,
    },
    {
      width: headerWidth.achieveY11,
      sortKey: 'y11',
      text: `${nowYear != null ? (nowYear - 11) % 100 : ''}`,
      className: classes.header,
    },
    {
      width: headerWidth.achieveY10,
      sortKey: 'y10',
      text: `${nowYear != null ? (nowYear - 10) % 100 : ''}`,
      className: classes.header,
    },
    {
      width: headerWidth.achieveY9,
      sortKey: 'y9',
      text: `${nowYear != null ? (nowYear - 9) % 100 : ''}`,
      className: classes.header,
    },
    {
      width: headerWidth.achieveY8,
      sortKey: 'y8',
      text: `${nowYear != null ? (nowYear - 8) % 100 : ''}`,
      className: classes.header,
    },
    {
      width: headerWidth.achieveY7,
      sortKey: 'y7',
      text: `${nowYear != null ? (nowYear - 7) % 100 : ''}`,
      className: classes.header,
    },
    {
      width: headerWidth.achieveY6,
      sortKey: 'y6',
      text: `${nowYear != null ? (nowYear - 6) % 100 : ''}`,
      className: classes.header,
    },
    {
      width: headerWidth.achieveY5,
      sortKey: 'y5',
      text: `${nowYear != null ? (nowYear - 5) % 100 : ''}`,
      className: classes.header,
    },
    {
      width: headerWidth.achieveY4,
      sortKey: 'y4',
      text: `${nowYear != null ? (nowYear - 4) % 100 : ''}`,
      className: classes.header,
    },
    {
      width: headerWidth.achieveY3,
      sortKey: 'y3',
      text: `${nowYear != null ? (nowYear - 3) % 100 : ''}`,
      className: classes.header,
    },
    {
      width: headerWidth.achieveY2,
      sortKey: 'y2',
      text: `${nowYear != null ? (nowYear - 2) % 100 : ''}`,
      className: classes.header,
    },
    {
      width: headerWidth.achieveY1,
      sortKey: 'y1',
      text: `${nowYear != null ? (nowYear - 1) % 100 : ''}`,
      className: classes.header,
    },
    {
      width: headerWidth.achieveY0,
      sortKey: 'y0',
      text: `${nowYear != null ? (nowYear - 0) % 100 : ''}`,
      className: classes.header,
    },
    {
      width: headerWidth.achieveFutuShuuki,
      sortKey: 'futuShuuki',
      text: '普通周期',
      className: classes.header,
    },
    {
      width: headerWidth.achieveEqReportNo,
      sortKey: 'saimituShuuki',
      text: '細密周期',
      className: classes.header,
    },
  ];

  // 画面遷移で送られた情報を設定する
  const locationSet = () => {
    // 初期値のままの場合
    if (currentPage === 0) {
      setCurrentPage(1);
    }
    // 戻るでの状態再現のフラグがTrueの場合
    if (backFlg.eqAchieveList) {
      setSortConfig({
        key: pageInfo.sortKey,
        direction: pageInfo.sortDirection,
      });
      setCurrentPage(pageInfo.page);
      // 一覧のテーブルがあるか確認
      if (containerRef.current) {
        setScroll(pageInfo.scrollPosition);
      }
      setBackFlg({ ...backFlg, eqAchieveList: false });
    }
  };

  // 一覧のページ変更処理
  const pageChange = (num: number) => {
    setScroll(0);
    setCurrentPage((prevPage) => {
      let newPage = prevPage + num;
      const tempTotalPages = Math.ceil(totalData / perPage);
      const totalPages = tempTotalPages > 0 ? tempTotalPages : 1;

      if (newPage < 1) newPage = 1;
      if (newPage > totalPages) newPage = totalPages;

      return newPage;
    });
  };

  // ソート機能の関数など
  const sortStart = (key: string) => {
    pageChange(1 - currentPage); // はじめのページに戻る
    setScroll(0); // 表のスクロールバーをリセット
    let direction = 'asc';
    if (
      sortConfig &&
      sortConfig.key === key &&
      sortConfig.direction === 'asc'
    ) {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  // 初回画面表示時の処理
  useEffect(() => {
    setLoading(true); // 非同期処理前にsetLoading(true)
    locationSet();
    Promise.all([
      requestOneEquipment(urlOneEquipment, {
        equipmentId: Number(id),
      }),
    ])
      .then((responses) => {
        setSubData(responses[0].data); // 設備情報
      })
      .catch((error) => {
        errorCheck(error); // エラー内容を確認
      })
      .finally(() => {
        setLoading(false); // 非同期処理後にsetLoading(false)
      });
  }, []);

  // データ更新時の処理
  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = scroll;
    }
  }, [data]);

  // 設備情報の取得
  useEffect(() => {
    setLoading(true); // 非同期処理前にsetLoading(true)
    Promise.all([
      requestCountEqMaint(urlCounteqMaint, {
        custEqId: Number(id),
      }),
      requestEqMaintList(urlEqMaintList, {
        custEqId: Number(id),
        number: perPage,
        page: currentPage,
        sortKey: sortConfig.key,
        sortDirection: sortConfig.direction,
      }),
    ])
      .then((responses) => {
        setTotalData(responses[0].data?.dataNum ?? 0); // 件数
        setNowYear(responses[0].data?.year ?? null); // 現在年
        setData(responses[1].data); // 設備情報
      })
      .catch((error) => {
        errorCheck(error); // エラー内容を確認
      })
      .finally(() => {
        setLoading(false); // 非同期処理後にsetLoading(false)
      });
  }, [currentPage, sortConfig]);

  return (
    <LoadingOverlay
      active={loading}
      className={classes.load}
      spinner
      text="データを読み込んでいます..."
    >
      <div className={classes.root}>
        <Button
          variant="primary"
          className="my-2"
          onClick={() => {
            history.push(`${routeName.eqMaintMenu}/${id}`);
          }}
        >
          戻る
        </Button>
        <br />
        <DataDisp userdata={authContext} data={subdata} />
        <div>点検実績（西暦 年）15年 ◎：製造年 ●：点検実施年</div>
        <div className={`${classes.paging} ${classes.eqAchieveListWidth}`}>
          <Paging
            totalData={totalData}
            currentPage={currentPage}
            perPage={perPage}
            onPageChange={pageChange}
          />
        </div>
        <TableContainer
          component={Paper}
          className={`${classes.container} ${classes.eqAchieveListHeight} ${classes.eqAchieveListWidth}`}
          ref={containerRef}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {/* ヘッダのセルを生成 */}
                {headerCellProps.map(({ width, sortKey, text, className }) => (
                  <TableCell width={width} className={className}>
                    {sortKey != null && (
                      <Button
                        variant="link"
                        onClick={() => sortStart(sortKey)}
                        className={classes.linkButton}
                      >
                        {text}
                        {sortConfig &&
                          sortConfig.key === sortKey &&
                          sortKey != null &&
                          sortKey !== '' &&
                          (sortConfig.direction === 'asc' ? '▲' : '▼')}
                      </Button>
                    )}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((d, index) => (
                <TableRow
                  className={index % 2 === 0 ? classes.evenRow : classes.oddRow}
                >
                  <TableCell className={`${classes.cell} ${classes.numRow}`}>
                    {d.mstId || blank}
                  </TableCell>
                  <TableCell className={`${classes.cell} ${classes.stringRow}`}>
                    {d.deviceNameDsp ?? ''}
                  </TableCell>
                  <TableCell className={`${classes.cell} ${classes.stringRow}`}>
                    {d.seizoNo ?? ''}
                  </TableCell>
                  <TableCell className={`${classes.cell} ${classes.numRow}`}>
                    {d.nonyuYear ?? ''}
                  </TableCell>
                  <TableCell className={`${classes.cell} ${classes.stringRow}`}>
                    {d.y14 ?? ''}
                  </TableCell>
                  <TableCell className={`${classes.cell} ${classes.stringRow}`}>
                    {d.y13 ?? ''}
                  </TableCell>
                  <TableCell className={`${classes.cell} ${classes.stringRow}`}>
                    {d.y12 ?? ''}
                  </TableCell>
                  <TableCell className={`${classes.cell} ${classes.stringRow}`}>
                    {d.y11 ?? ''}
                  </TableCell>
                  <TableCell className={`${classes.cell} ${classes.stringRow}`}>
                    {d.y10 ?? ''}
                  </TableCell>
                  <TableCell className={`${classes.cell} ${classes.stringRow}`}>
                    {d.y9 ?? ''}
                  </TableCell>
                  <TableCell className={`${classes.cell} ${classes.stringRow}`}>
                    {d.y8 ?? ''}
                  </TableCell>
                  <TableCell className={`${classes.cell} ${classes.stringRow}`}>
                    {d.y7 ?? ''}
                  </TableCell>
                  <TableCell className={`${classes.cell} ${classes.stringRow}`}>
                    {d.y6 ?? ''}
                  </TableCell>
                  <TableCell className={`${classes.cell} ${classes.stringRow}`}>
                    {d.y5 ?? ''}
                  </TableCell>
                  <TableCell className={`${classes.cell} ${classes.stringRow}`}>
                    {d.y4 ?? ''}
                  </TableCell>
                  <TableCell className={`${classes.cell} ${classes.stringRow}`}>
                    {d.y3 ?? ''}
                  </TableCell>
                  <TableCell className={`${classes.cell} ${classes.stringRow}`}>
                    {d.y2 ?? ''}
                  </TableCell>
                  <TableCell className={`${classes.cell} ${classes.stringRow}`}>
                    {d.y1 ?? ''}
                  </TableCell>
                  <TableCell className={`${classes.cell} ${classes.stringRow}`}>
                    {d.y0 ?? ''}
                  </TableCell>
                  <TableCell className={`${classes.cell} ${classes.numRow}`}>
                    {d.futuShuuki ?? ''}
                  </TableCell>
                  <TableCell className={`${classes.cell} ${classes.numRow}`}>
                    {d.saimituShuuki ?? ''}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </LoadingOverlay>
  );
};

export default EqAchievelist;
